<template>
    <div>
        <div class="engage-container">
            <img class="logo" src="/media/images/web_search/engage.png" alt="Logo" />
            <div class="separator"></div>
            <div class="main-topic text-content">
                <h2>Sicherheit für<br /> Ihren Projekteinsatz</h2>
                <p>
                    Sie haben bereits einen Kunden für ihren nächsten Projekt-Einsatz? Bereits ab 4% Umsatz-Beteiligung
                    sichern wir ihre Projekt-Risiken ab. Nehmen Sie sich für Ihr nächstes Projekt die Deutsche Interim
                    AG als starken Partner an die Seite und vertrauen Sie auf unsere langjährige Erfahrung in der
                    Abwicklung von Interim Mandaten.
                </p>
            </div>
        </div>
        <div class="tile-row-two">
            <div class="tile-box">
                <h3>Sofort-Geld Garantie</h3>
                <p>
                    Die Deutsche Interim AG überweist Ihnen den Rechnungsbetrag bereits 5 Werktage nach
                    Rechnungsstellung unabhängig vom vereinbarten Zahlungsziel des Kunden.
                </p>
                <h3>Schutz vor Zahlungsausfall</h3>
                <p>
                    Profitieren Sie von unserer Partnerschaft mit ABS Factoring, einem der führenden Dienstleister auf
                    diesem Gebiet. Zusammen mit ABS Factoring bieten wir eine Zahlungsausfall-Garantie oder die
                    Durchsetzung einer Vorauskassen-Regelung.
                </p>
            </div>
            <div class="tile-box tile-image-only">
                <img class="tile-logo" src="/media/images/web_search/schutz.jpg" alt="Logo" />
            </div>
        </div>
        <div class="tile-row-two">
            <div class="tile-box tile-image-only">
                <img class="tile-logo" src="/media/images/web_search/service.jpg" alt="Logo" />
            </div>
            <div class="tile-box">
                <h3>Vertrags-Service</h3>
                <p>
                    Profitieren Sie auch bei der Vertragsgestaltung von unserer langjährigen Erfahrung im Interim
                    Management. Wir erstellen für Sie und Ihre Kunden die passende Vertragsvorlage mit individueller
                    Anpassung an die jeweilige Mandatssituation.
                </p>
                <h3>Versicherungs- und Haftungsschutz</h3>
                <p>
                    Für die Dauer des Mandatseinsatzes sind Sie mit uns versichert. Sie brauchen keine zusätzliche
                    Versicherung abzuschließen. Besondere, mandatsbezogene Risiken bewerten wir individuell. </p>
            </div>
        </div>
        <div class="contact-container">
            <img class="logo avatar" src="/media/images/web_search/tilo_ceo.jpg" alt="Logo" />
            <div class="separator"></div>
            <div class="text-content">
                <h2>Tilo Ferrari / CEO</h2>
                <p>
                    Sie wollen pünktlich Ihr Geld und ihre Projektrisiken absichern? Dann lassen Sie uns sprechen!
                </p>
                <div class="socials d-flex flex-row justify-content-center">
                    <div class="mail">
                        <a href="mailto:tilo.ferrari@deutscheinterim.com">tilo.ferrari@deutscheinterim.com</a>

                    </div>
                    <div class="phone">
                        <a href="tel:+49-69-173201231">+49 69 173201231</a>

                    </div>
                    <div class="calendly">
                        <a href="https://calendly.com/tiloferrari/informationsgespraech"
                            target="_blank">https://calendly.com/tiloferrari/informationsgespraech</a>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "Engage",
};
</script>

<style scoped>
.engage-container {
    display: flex;
    align-items: flex-start;
    background: #CDDEE2;
    padding: 20px;
    border-radius: 12px;
    border-top-left-radius: 0;
    margin: 0 auto;
}

.contact-container {
    display: flex;
    align-items: flex-start;
    padding: 20px;
    border-top-left-radius: 0;
    margin: 0 auto;
    background-color: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 30px;
    padding: 24px;
    display: flex;
    margin-top: 24px;
    margin-bottom: 33px;
}

.logo {
    width: 200px;
    height: auto;
    margin-top: 37px;
}

.separator {
    width: 6px;
    background-color: #338EA3;
    height: 100%;
    min-height: 280px;
    margin-left: 30px;
    margin-right: 30px;
    margin-top: 40px;
}

.text-content {
    max-width: 700px;
}

.main-topic h2 {
    text-align: left;
    font: normal normal 500 42px/48px Cormorant Garamond;
    letter-spacing: -0.84px;
    color: #191919;
    opacity: 1;
}

.main-topic p {
    text-align: left;
    font: normal normal normal 20px/30px Barlow;
    letter-spacing: -0.4px;
    color: #000000;
    opacity: 1;
}

p {
    font-size: 16px;
    line-height: 1.5;
}

.tile-row-two {
    display: flex;
    gap: 20px;
    margin-top: 30px;
    align-items: stretch;
}

.tile-box {
    flex: 1 1 auto;
    background-color: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 30px;
    padding: 24px;
    flex-direction: column;
    justify-content: center;
}

.tile-box h3 {
    text-align: left;
    font: normal normal 500 28px/32px Barlow;
    letter-spacing: -0.56px;
    color: #191919;
    opacity: 1;
}

.tile-box p {
    text-align: left;
    font: normal normal normal 20px/30px Barlow;
    letter-spacing: -0.4px;
    color: #000000;
}

.tile-image-only {
    flex: 0 0 325px;
    display: flex;
    align-items: stretch;
    justify-content: center;
    text-align: center;
}

.tile-image-only img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 18px;
}

.contact-container h2 {
    text-align: left;
    font: italic normal normal 26px/55px Barlow;
    letter-spacing: -0.52px;
    color: #191919;
    opacity: 1;
}

.contact-container p {
    text-align: left;
    font: normal normal 500 36px/42px Cormorant Garamond;
    letter-spacing: -0.72px;
    color: #191919;
    opacity: 1;
}

.logo.avatar {
    border-radius: 50%;
    width: 260px;
}

.mail a {
    display: inline-block;
    width: 50px;
    height: 50px;
    background-repeat: no-repeat;
    font-size: 0;
    margin: 4px 7px;
    background-image: url(/media/images/web_search/mail.svg);
}

.phone a {
    display: inline-block;
    width: 50px;
    height: 50px;
    background-repeat: no-repeat;
    font-size: 0;
    margin: 4px 7px;
    background-image: url(/media/images/web_search/phone.svg);
}

.calendly a {
    display: inline-block;
    width: 50px;
    height: 50px;
    background-repeat: no-repeat;
    font-size: 0;
    margin: 4px 7px;
    background-image: url(/media/images/web_search/calendar.svg);
}

.socials {
    display: flex;
}

@media (max-width: 768px) {

    .tile-row-two,
    .contact-container,
    .engage-container {
        flex-direction: column;
        align-items: center;
    }

    .separator {
        display: none;
    }

    .logo {
        margin-top: 0;
        width: 150px;
    }

    .tile-box,
    .tile-image-only {
        width: 100%;
        max-width: 100%;
    }

    .socials {
        flex-direction: column;
        align-items: center;
    }
}
</style>